<template>
    <v-card class="bg-white shadow rounded px-2 pt-2 pb-4 border border-white">
        <div class="divide-y-4 divide-opacity-100" :class="manejarEstatus(tarjeta['Estatus'])">
            <div class="flex justify-between">
                <div v-for="(item, index) in informacion" :key="index">
                    <vs-tooltip v-if="index == 0" position="right" :text="obtenerTooltip(tarjeta[item])">
                        <v-icon :color="obtenerColor(tarjeta[item])">{{obtenerIcono(tarjeta[item])}}</v-icon>
                    </vs-tooltip>
                    <span v-if="index == 1" :class="{ 'font-medium': index == 0, 'text-indigo-700':index==1 }" class="md:text-xs">{{tarjeta[item]}}</span>
                </div>
            </div>
            <div>
                <v-card :id="tarjeta.ClaveTar" class="overflow-hidden mx-1 mb-1">
                   
                    <v-card-text class="pa-0">
                        <div class="flex justify-betweenn">
                            <div v-for="(item, index) in encabezado" :key="index" :id="encabezado[index]">
                                <span v-if="index == 0" :class="{ 'font-medium': index == 0, 'text-indigo-800':index==1 }" class="md:text-sm truncate">{{tarjeta[item]}}</span>
                                <!--<span v-if="index == 0" :class="{ 'font-medium': index == 0, 'text-gray-800':index==1 }" class="md:text-xs">{{tarjeta[item]}}</span>-->

                                <span v-if="index == 1" @click="redireccionarPorReporte(tarjeta[item])" :class="{ 'font-medium': index == 1, 'text-indigo-800':index==1 }" class="md:text-sm truncate md:overflow-clip cursor-pointer ">{{tarjeta[item]}}</span>
                                <!--<span @click="redireccionarPorReporte(tarjeta[item])" :class="{ 'font-medium': index == 0, 'text-indigo-800':index==1 }" class="md:text-sm truncate md:overflow-clip cursor-pointer ">{{tarjeta[item]}}</span>-->

                                <span v-if="index == 2" :class="{ 'font-medium': index == 2, 'text-gray-700':index==2 }" class="md:text-xs">{{tarjeta[item]}}</span>
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-text class="pa-5 pb-0" style="width:250px">
                        <div class="grid auto-rows-max  space-y-2">
                            
                            <div v-for="(item, index) in cuerpo" :key="index">
                                <span v-if="index != 5" :class="{ 'font-medium': index != 0 }" class="break-words md:text-xs">{{tarjeta[item]}}</span>

                                <div v-show="valor">
                                    <span v-if="index == 5 && tarjeta[item].length >80" :class="{ 'font-medium': index != 0 }" class="break-words md:text-xs">{{tarjeta[item].substring(0,80)+" "}}<a class="enlace" @click="leermas()">...Leer más</a></span>
                                </div>
                                <div v-show="valor2">
                                    <span v-if="index == 5 " :class="{ 'font-medium': index != 0 }" class="break-words md:text-xs">{{tarjeta[item]}}<a class="enlace" @click="leermenos()">...Ocultar</a></span>
                                </div>
                                <!--<span v-if="index == 5 && tarjeta[item].length >150" id="comp+tarjeta.ClaveTar" :class="{ 'font-medium': index != 0 }" class="break-words md:text-xs">{{tarjeta[item].substring(0,80)+" "}}<a class="enlace" @click="leermas(tarjeta[item],item,index,tarjeta.ClaveTar)">...Leer más</a></span>-->


                                <span v-if="index == 5 && tarjeta[item].length <=80" :class="{ 'font-medium': index != 0 }" class="break-words md:text-xs">{{tarjeta[item]}}</span>


                            </div>
                        </div>
                    </v-card-text>


                    <div class="pa-2 flex justify-between">
                        <div class="grid grid-flow-col auto-cols-max md:auto-cols-1  space-x-2">
                            <div v-for="(item, index) in footer" :key="index">
                                <vs-tooltip v-if="index==0 &&  tarjeta[item]>0" position="right" :text="obtenerRelevancia(tarjeta[item])">
                                    <v-icon :color="obtenerRelevanciaColor(tarjeta[item])">mdi-bookmark</v-icon>
                                </vs-tooltip>
                                <span v-if="index==1" :class="{ 'text-gray-500': index == 0 }" class="md:text-xs truncate md:overflow-clip">{{tarjeta[item]}}</span>
                                <vs-tooltip v-if="index==2 &&  tarjeta[item]==0" position="right" :text="'Conductor Detenido'">
                                    <v-icon :color="'#FC2B24'">mdi-account-alert</v-icon>
                                </vs-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="pa-2 flex justify-between">
                        <div v-for="(item, index) in reporte" :key="index" class="grid grid-flow-col auto-cols-max md:auto-cols-2  space-x-2">
                            
                            <div v-if="tarjeta.Seguimiento">
                                <Documentacion :nrreporte="tarjeta[item]" pantalla="T"></Documentacion>

                            </div>
                            <div>
                                <!--<vs-tooltip position="right" :text="'Ingresa Comentario'">
                                    <v-icon v-if="seguimientoReporte" x-large class="task-circle ml-1" :color="'success'">mdi-circle-medium</v-icon>-->
                                    <!-- <AppLink :to="seguimiento">Click Me</AppLink> -->
                                    <!--<router-link :to="{name: 'seguimiento'}">
                                        <button id="myButton" class="foo bar"> <v-icon :color="'#B3C9F1'"> {{'mdi-file-document-edit'}}</v-icon></button>
                                    </router-link>-->
                                    <!-- <v-icon :color="'#B3C9F1'" > {{'mdi-file-document-edit'}}</v-icon>  -->

                                <!--</vs-tooltip>-->
                                <Movimiento :nrreporte="tarjeta[item]" pantalla="T"></Movimiento>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="pa-2 flex justify-between">
                     <div class="grid grid-flow-col auto-cols-max md:auto-cols-1  space-x-2">
                     <div v-for="(item, index) in encabezado" :key="index">
                       <vs-tooltip position="right" :text="'Adjuntar Documentos'">
                         <v-icon v-if="tarjeta.Seguimiento" :color="'#B3C9F1'" @click="redireccionarMovimiento(tarjeta[item],tarjeta.ceclave), tarjeta.Seguimiento=1">{{'mdi-folder-upload'}}</v-icon>
                       </vs-tooltip>
                        <vs-tooltip   position="right" :text="'Ingresa Comentario'">
                          <v-icon v-if="seguimientoReporte" x-large class="task-circle ml-1" :color="'success'">mdi-circle-medium</v-icon>
                         <v-icon :color="'#B3C9F1'" @click="redireccionarMovimiento(tarjeta[item],tarjeta.ceclave), seguimientoReporte=1">{{'mdi-file-document-edit'}}</v-icon>
                       </vs-tooltip>
                     </div>
                  </div>
                 </div> -->

                </v-card>
            </div>
        </div>
        <div class="centerx">
            <!--<div v-show="pantallaMovimiento2">-->
            <!--<vs-popup title="Alta Movimiento" fullscreen :active.sync="pantallaMovimiento2">-->
            <!--<Movimiento :nrreporte="reporte" pantalla="T" v-on:pantallaMovimiento="cambiarPantalla($event)"></Movimiento>-->
            <!--<div v-for="(item, index) in encabezado" :key="index" class="grid grid-flow-col auto-cols-max md:auto-cols-2  space-x-2">
                <Movimiento :nrreporte="tarjeta[item]" pantalla="T"></Movimiento>
            </div>-->

            <!--</vs-popup>-->
            <!--  -->
        <!--</div>
        <div class="centerx">-->
            <vs-popup title="Redireccionar" :active.sync="alert">
                <p style="text-align: center">
                    <v-btn class="ma-2" @click="redirec()"
                           color="blue" dark> Ir <v-icon dark right>mdi-table-search</v-icon></v-btn>
                </p>
            </vs-popup>
        </div>
        <!-- </div> -->
    </v-card>
  
</template>
<script>
    import { mapState } from 'vuex';
    import Movimiento from "@/components/pages/operacion/Seguimiento.vue";
    import Documentacion from "@/components/pages/operacion/Reportes/Documentacion.vue";
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    export default {
        props: ['tarjeta'],
        components: {
            Movimiento,
            Documentacion
        },
        data() {
            return {
                pantalla: "T",
                pantallaMovimiento2: false,
                //reporte:"",
                valor: true,
                valor2: false,
                informacion: [],
                encabezado: [],
                cuerpo: [],
                footer: [],
                reporte: [],
                ceclave: [],
                alert: false,
                url: "",
                seguimientoReporte: 0,
                items: [
                    { title: 'Inicio', icon: 'mdi-vector-circle-variant', link: { name: 'seguimiento' } },
                    { title: 'Tablero', icon: 'mdi-trello', link: { name: 'seguimiento' } },
                ],
            }
        },
        computed: {
            ...mapState(['domain']),
            badgeColor() {
                const mappings = {
                    Design: "purple",
                    "Feature Request": "teal",
                    Backend: "blue",
                    QA: "green",
                    default: "teal"
                };
                return mappings.default;
            },
        },
        methods: {

            manejarEstatus(estatus) {
                let temp = {};
                switch (estatus) {
                    case 1:
                        temp = { 'divide-gray-400': 1 }
                        break;
                    case 2:
                        temp = { 'divide-green-500': 2 }
                        break;
                    case 3:
                        temp = { 'divide-yellow-200': 3 }
                        break;
                    case 4:
                        temp = { 'divide-yellow-400': 4 }
                        break;
                    case 5:
                        temp = { 'divide-red-500': 5 }
                        break;
                }
                return temp;
            },
            obtenerTooltip(tipo) {
                let temp;
                switch (tipo) {
                    case 'Lib. Fis.':
                        temp = 'Liberación Fisica'
                        break;
                    case 'Lib. Jur.':
                        temp = 'Liberación Jurídica'
                        break;
                    case 'Robo':
                        temp = 'Robo'
                        break;
                }
                return temp;
            },
            obtenerColor(tipo) {
                let temp;
                switch (tipo) {
                    case 'Lib. Fis.':
                        temp = '#8e44ad'
                        break;
                    case 'Lib. Jur.':
                        temp = '#f39c12'
                        break;
                    case 'Robo':
                        temp = '#0A0A0A'
                        break;
                }
                return temp;
            },
            obtenerIcono(tipo) {
                let temp;
                switch (tipo) {
                    case 'Lib. Fis.':
                        temp = 'mdi-car'
                        break;
                    case 'Lib. Jur.':
                        temp = 'mdi-car-traction-control'
                        break;
                    case 'Robo':
                        temp = 'mdi-car-off'
                        break;
                }
                return temp;
            },
            obtenerRelevanciaColor(tipo) {
                let temp = "";
                switch (tipo) {
                    case 1:
                        temp = temp = '#F41207'
                        break;
                    case 2:
                        temp = '#6F1E51'
                        break;
                    case 3:
                        temp = '#FFC312'
                        break;

                }
                return temp;
            },
            obtenerRelevancia(tipo) {
                let temp = "";
                switch (tipo) {
                    case 1:
                        temp = "Homicidio"
                        break;
                    case 2:
                        temp = "Lesiones-Hospitalización"
                        break;
                    case 3:
                        temp = "Daños> $50,000"
                        break;

                }
                return temp;
            },
            async leermas() {
                this.valor = false;
                this.valor2 = true;
            },
            async leermenos() {
                this.valor = true;
                this.valor2 = false;
            },
            redirecSeguimiento() {
                //console.log("entra");
                this.$router.push('/operacion/seguimiento')
                //  window.open(`${this.domain.domainAusa}/operacion/reporte/seguimiento`);
                //console.log(`${this.domain.domainAusa}/operacion/seguimiento`);

            },
            redirec() {
                window.open(this.url, '_blank');
                this.alert = false
            },

            async redireccionarPorReporte(data) {
                var reporte = data.split('-')[0];
                var indice = data.split('-')[1];

                var formData = new FormData();
                formData.append("nrreporte", reporte);
                formData.append("svindice", indice);

                await this.axios.post(`${this.domain.domainNameForApi}Tablero/ObtenerDatosReporte`, formData).then(response => {

                    MetodosGenerales.guardarEnSesionInfoReporteTablero(response.data[0], this);

                });


            },

            redireccionarMovimiento(data, ceclave) {
                var formData = new FormData();
                formData.append("nrreporte", data.split('-')[0]);
                formData.append("svindice", data.split('-')[1]);
                formData.append("ceclave", ceclave);
                this.axios.post(`${this.domain.domainNameForApi}Tablero/URLMovimientos`, formData).then(response => {
                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        this.alert = true;
                        this.url = `${this.domain.domainAusa}${response.data.value}`;

                    } else {
                        this.alert = false;
                        window.open(`${this.domain.domainAusa}${response.data.value}`);

                    }
                });
            }
        },
        mounted() {

            let temp = Object.keys(this.tarjeta);
            this.informacion = temp.filter(item => item.startsWith('Dato') && item.endsWith('I')).sort();
            this.encabezado = temp.filter(item => item.startsWith('Dato') && item.endsWith('E')).sort();
            this.cuerpo = temp.filter(item => item.startsWith('Dato') && item.endsWith('C')).sort();
            this.footer = temp.filter(item => item.startsWith('Dato') && item.endsWith('F')).sort();
            this.reporte = temp.filter(item => item.startsWith('Dato') && item.endsWith('R')).sort();
            if (document.getElementById(this.tarjeta.ClaveTar)) {
                document.getElementById(this.tarjeta.ClaveTar).classList.remove("con-vs-card");
            }
        },
    };
</script>
<style>
    #Dato2E {
        width: 129px;
    }
</style>
<style lang="scss">
    .enlace {
        display: inline;
        border: 0;
        padding: 0;
        margin: 0;
        background: none;
        color: #386bd4;
        font-family: arial, sans-serif;
        font-size: 1em;
        line-height: 1em;
    }

        .enlace:hover {
            text-decoration: none;
            color: #0000cc;
            cursor: pointer;
            text-decoration: underline;
        }
</style>